import React from "react";
import styles from "./Footer.module.scss";
import CookieButton from "../elements/CookieButton";
import SocialMediaIcon from "./SocialMediaIcon";

interface FooterNavigationProps {
  className?: string;
}

const FooterNavigation: React.FC<FooterNavigationProps> = ({ className }) => (
  <nav 
    className={`${styles["o-footer__nav"]} ${className || ""}`}
    aria-label="Footer navigation"
  >
    <div className={styles["c-footer-nav"]}>
      {/* Secondary Navigation */}
      <nav className={styles["c-footer-nav__secondary"]} aria-label="Legal and resources">
        <ul className={`${styles["u-mono-03"]} ${styles["u-uppercase"]}`}>
          <li><a href="https://www.solflare.com/privacy-policy/">Privacy Policy</a></li>
          <li><CookieButton /></li>
          <li><a href="https://www.solflare.com/sitemap/">Sitemap</a></li>
          <li>
            <a 
              className="branding_footer_link" 
              href="https://www.solflare.com/solflare-brand-kit.zip" 
              download
              aria-label="Download Solflare brand kit"
            >
              Brand Kit
            </a>
          </li>
        </ul>
      </nav>

      {/* Primary Navigation */}
      <nav className={styles["c-footer-nav__primary"]} aria-label="Main footer navigation">
        <ul>
          <li>
            <h3 className={`${styles["u-mono-03"]} ${styles["u-uppercase"]} ${styles["c-footer-nav__primary-section-title"]}`}>
              Product
            </h3>
            <ul>
              <li><a className={styles["u-bold-08"]} href="https://www.solflare.com/product/">Overview</a></li>
              <li><a className={styles["u-bold-08"]} href="https://www.solflare.com/essentials/">Essential features</a></li>
              <li><a className={styles["u-bold-08"]} href="https://www.solflare.com/security/">Security</a></li>
              <li><a className={styles["u-bold-08"]} href="https://www.solflare.com/trading/">Trading</a></li>
              <li><a className={styles["u-bold-08"]} href="https://www.solflare.com/stake/">Staking</a></li>
            </ul>
          </li>
          <li>
            <h3 className={`${styles["u-mono-03"]} ${styles["u-uppercase"]} ${styles["c-footer-nav__primary-section-title"]}`}>
              Education
            </h3>
            <ul>
              <li><a className={styles["u-bold-08"]} href="https://www.solflare.com/resources/">Resources</a></li>
              <li><a className={styles["u-bold-08"]} href="hhttps://www.solflare.com/explore-solana/">Explore Solana</a></li>
              </ul>
              </li>
          <li>
            <h3 className={`${styles["u-mono-03"]} ${styles["u-uppercase"]} ${styles["c-footer-nav__primary-section-title"]}`}>
              Company
            </h3>
            <ul>
              <li><a className={styles["u-bold-08"]} href="https://www.solflare.com/about/">About</a></li>
              <li><a className={styles["u-bold-08"]} href="https://www.solflare.com/careers/">Careers</a></li>
              <li><a className={styles["u-bold-08"]} href="https://www.solflare.com/contact/">Contact</a></li>
            </ul>
          </li>
        </ul>
      </nav>

      {/* Social Media Navigation */}
      <nav className={styles["c-footer-nav__social"]} aria-label="Social media links">
        <SocialMediaIcon 
          platform="x"
          href="https://x.com/solflare/"
          ariaLabel="Follow Solflare on X (formerly Twitter)"
        />
        <SocialMediaIcon 
          platform="youtube"
          href="http://www.youtube.com/@SolflareWallet"
          ariaLabel="Subscribe to Solflare on YouTube"
        />
        <SocialMediaIcon 
          platform="linkedin"
          href="https://www.linkedin.com/company/solflare-official/"
          ariaLabel="Follow Solflare on LinkedIn"
        />
      </nav>
    </div>
  </nav>
);

export default FooterNavigation; 